import {fetchBuySellReport} from '../services/reportService';
import moment from 'moment';
type Period = 'default' | '2Y' | '1Y' | '6M' | '3M' | '1M' | '1W';
export function getBuySellReport(period: Period, symbol: string) {
    let endDate = moment().format('YYYY-MM-DD');
    let startDate: string;
    console.log("getForeignVolumeReport period:", period);
    console.log("getForeignVolumeReport symbol:", symbol);
  switch (period) {
    case '2Y':
        startDate = moment().subtract(2, 'years').format('YYYY-MM-DD');
        break;
      case '1Y':
        startDate = moment().subtract(1, 'years').format('YYYY-MM-DD');
        break;
      case '6M':
        startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
        break;
      case '3M':
        startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
        break;
      case '1M':
        startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
        break;
      case '1W':
        startDate = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
        break;
      default:
        startDate = '';
        endDate = '';
        break;
      }
return (dispatch: any) => {
    fetchBuySellReport(symbol, startDate, endDate).then((data) => { 
        dispatch({type:'RECEIVE_BUY_SELL_REPORT', report: data, loading:false});
     }).catch((err) => {
        console.error('Failed to load report:', err);
        dispatch({type:'RECEIVE_BUY_SELL_REPORT', report: [], loading: true});
    });
    };
}

export function setBuySellReportLoading(loading: boolean) {
  console.log("setBuySellReportLoading:", loading);
  return (dispatch: any)=>{
      dispatch({type:'SET_BUY_SELL_REPORT_LOADING', loading: loading});
  };
}